import b from 'b_';
import { WarningFilled as WarningIcon } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import * as lessonSelectors from 'common.components/lesson/selectors';

import * as selectors from '../selectors';

interface Props {
    disabled: boolean;
    index: number;
    isDifficult: boolean;
    onClick?: (problemId: number) => void;
    problemLinkId: number;
}

export const ResultsHeaderCardCell = ({ disabled, index, isDifficult, onClick, problemLinkId }: Props) => {
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const problems = useSelector(selectors.getCommonProblems);

    const handleProblemClick = () => {
        if (disabled) {
            return;
        }

        const problemId = problems.find((problem) => problem.id === problemLinkId)?.problem?.id;

        ym('reachGoal', 'ResultTableToProblem', {
            clessonId,
            problem_id: problemId,
        });

        if (problemId && onClick) {
            onClick(problemId);
        }
    };

    return (
        <>
            <div className={b('results', 'problem-cell', { disabled })} {...accessibleClick(handleProblemClick)}>
                <Text>{index + 1}</Text>
            </div>
            {isDifficult && <WarningIcon className="results__problem-cell-icon" />}
        </>
    );
};
